// extracted by mini-css-extract-plugin
export default {"resultTable":"TourTable_resultTable__ugcp2"};